export class GasResolver {
    constructor(providers) {
        this.providers = providers || [];
    }
    getGas({ address, network, token, recipientAddress, amount, wallet }) {
        const provider = this.providers.find(p => p.supportsNetwork(network));
        if (!provider)
            return;
        return provider.getGas({ address, network, token, recipientAddress, wallet, amount });
    }
}
